import { Box, Divider, Typography } from '@mui/material';
import { formatDateWhitoutHour } from '../../services/helpers/helpers';
import { useEffect, useState } from 'react';
import { DamsServices } from '../../services/api/dams/DamServices';

const data = [
	{
		'time': '2025-06-25T09:00:00Z',
		'values': {
			'altimeterSettingAvg': 1021.02,
			'altimeterSettingMax': 1023.58,
			'altimeterSettingMin': 1019.18,
			'cloudBaseAvg': 0.2,
			'cloudBaseMax': 1.8,
			'cloudBaseMin': 0,
			'cloudCeilingAvg': 0,
			'cloudCeilingMax': 0,
			'cloudCeilingMin': 0,
			'cloudCoverAvg': 2,
			'cloudCoverMax': 17,
			'cloudCoverMin': 0,
			'dewPointAvg': 6.2,
			'dewPointMax': 9.4,
			'dewPointMin': 3.1,
			'evapotranspirationAvg': 0.106,
			'evapotranspirationMax': 0.396,
			'evapotranspirationMin': 0,
			'evapotranspirationSum': 2.54,
			'freezingRainIntensityAvg': 0,
			'freezingRainIntensityMax': 0,
			'freezingRainIntensityMin': 0,
			'humidityAvg': 57,
			'humidityMax': 89,
			'humidityMin': 32,
			'iceAccumulationAvg': 0,
			'iceAccumulationLweAvg': 0,
			'iceAccumulationLweMax': 0,
			'iceAccumulationLweMin': 0,
			'iceAccumulationLweSum': 0,
			'iceAccumulationMax': 0,
			'iceAccumulationMin': 0,
			'iceAccumulationSum': 0,
			'moonriseTime': '2025-06-25T10:07:49Z',
			'moonsetTime': '2025-06-25T20:56:45Z',
			'precipitationProbabilityAvg': 0,
			'precipitationProbabilityMax': 0,
			'precipitationProbabilityMin': 0,
			'pressureSeaLevelAvg': 1020.36,
			'pressureSeaLevelMax': 1023.78,
			'pressureSeaLevelMin': 1017.75,
			'pressureSurfaceLevelAvg': 946.71,
			'pressureSurfaceLevelMax': 949.56,
			'pressureSurfaceLevelMin': 942.62,
			'rainAccumulationAvg': 0,
			'rainAccumulationMax': 0,
			'rainAccumulationMin': 0,
			'rainAccumulationSum': 0,
			'rainIntensityAvg': 0,
			'rainIntensityMax': 0,
			'rainIntensityMin': 0,
			'sleetAccumulationAvg': 0,
			'sleetAccumulationLweAvg': 0,
			'sleetAccumulationLweMax': 0,
			'sleetAccumulationLweMin': 0,
			'sleetAccumulationLweSum': 0,
			'sleetAccumulationMax': 0,
			'sleetAccumulationMin': 0,
			'sleetIntensityAvg': 0,
			'sleetIntensityMax': 0,
			'sleetIntensityMin': 0,
			'snowAccumulationAvg': 0,
			'snowAccumulationLweAvg': 0,
			'snowAccumulationLweMax': 0,
			'snowAccumulationLweMin': 0,
			'snowAccumulationLweSum': 0,
			'snowAccumulationMax': 0,
			'snowAccumulationMin': 0,
			'snowAccumulationSum': 0,
			'snowIntensityAvg': 0,
			'snowIntensityMax': 0,
			'snowIntensityMin': 0,
			'sunriseTime': '2025-06-25T09:43:00Z',
			'sunsetTime': '2025-06-25T20:41:00Z',
			'temperatureApparentAvg': 15.1,
			'temperatureApparentMax': 23.2,
			'temperatureApparentMin': 4.7,
			'temperatureAvg': 15.1,
			'temperatureMax': 23.2,
			'temperatureMin': 4.7,
			'uvHealthConcernAvg': 0,
			'uvHealthConcernMax': 2,
			'uvHealthConcernMin': 0,
			'uvIndexAvg': 1,
			'uvIndexMax': 5,
			'uvIndexMin': 0,
			'visibilityAvg': 15.87,
			'visibilityMax': 16,
			'visibilityMin': 13.84,
			'weatherCodeMax': 1000,
			'weatherCodeMin': 1000,
			'windDirectionAvg': 98,
			'windGustAvg': 4.8,
			'windGustMax': 10.8,
			'windGustMin': 0.8,
			'windSpeedAvg': 1.3,
			'windSpeedMax': 2.2,
			'windSpeedMin': 0.3
		}
	},
	{
		'time': '2025-06-26T09:00:00Z',
		'values': {
			'altimeterSettingAvg': 1019.82,
			'altimeterSettingMax': 1022.14,
			'altimeterSettingMin': 1018.39,
			'cloudBaseAvg': 0.4,
			'cloudBaseMax': 3.5,
			'cloudBaseMin': 0,
			'cloudCeilingAvg': 0,
			'cloudCeilingMax': 0,
			'cloudCeilingMin': 0,
			'cloudCoverAvg': 7,
			'cloudCoverMax': 30,
			'cloudCoverMin': 0,
			'dewPointAvg': 12.1,
			'dewPointMax': 13.9,
			'dewPointMin': 9.9,
			'evapotranspirationAvg': 0.16,
			'evapotranspirationMax': 0.521,
			'evapotranspirationMin': 0,
			'evapotranspirationSum': 3.829,
			'freezingRainIntensityAvg': 0,
			'freezingRainIntensityMax': 0,
			'freezingRainIntensityMin': 0,
			'humidityAvg': 58,
			'humidityMax': 86,
			'humidityMin': 35,
			'iceAccumulationAvg': 0,
			'iceAccumulationLweAvg': 0,
			'iceAccumulationLweMax': 0,
			'iceAccumulationLweMin': 0,
			'iceAccumulationLweSum': 0,
			'iceAccumulationMax': 0,
			'iceAccumulationMin': 0,
			'iceAccumulationSum': 0,
			'moonriseTime': '2025-06-26T11:04:57Z',
			'moonsetTime': '2025-06-26T22:01:25Z',
			'precipitationProbabilityAvg': 0,
			'precipitationProbabilityMax': 0,
			'precipitationProbabilityMin': 0,
			'pressureSeaLevelAvg': 1017.84,
			'pressureSeaLevelMax': 1020.19,
			'pressureSeaLevelMin': 1015.19,
			'pressureSurfaceLevelAvg': 947.73,
			'pressureSurfaceLevelMax': 949.94,
			'pressureSurfaceLevelMin': 942.03,
			'rainAccumulationAvg': 0,
			'rainAccumulationMax': 0,
			'rainAccumulationMin': 0,
			'rainAccumulationSum': 0,
			'rainIntensityAvg': 0,
			'rainIntensityMax': 0,
			'rainIntensityMin': 0,
			'sleetIntensityAvg': 0,
			'sleetIntensityMax': 0,
			'sleetIntensityMin': 0,
			'snowAccumulationAvg': 0,
			'snowAccumulationLweAvg': 0,
			'snowAccumulationLweMax': 0,
			'snowAccumulationLweMin': 0,
			'snowAccumulationLweSum': 0,
			'snowAccumulationMax': 0,
			'snowAccumulationMin': 0,
			'snowAccumulationSum': 0,
			'snowIntensityAvg': 0,
			'snowIntensityMax': 0,
			'snowIntensityMin': 0,
			'sunriseTime': '2025-06-26T09:43:00Z',
			'sunsetTime': '2025-06-26T20:41:00Z',
			'temperatureApparentAvg': 21.3,
			'temperatureApparentMax': 28,
			'temperatureApparentMin': 13.5,
			'temperatureAvg': 21.4,
			'temperatureMax': 28.8,
			'temperatureMin': 13.5,
			'uvHealthConcernAvg': 0,
			'uvHealthConcernMax': 2,
			'uvHealthConcernMin': 0,
			'uvIndexAvg': 1,
			'uvIndexMax': 6,
			'uvIndexMin': 0,
			'visibilityAvg': 15.42,
			'visibilityMax': 16,
			'visibilityMin': 10.58,
			'weatherCodeMax': 1000,
			'weatherCodeMin': 1000,
			'windDirectionAvg': 103,
			'windGustAvg': 9.5,
			'windGustMax': 12.6,
			'windGustMin': 4.5,
			'windSpeedAvg': 3.6,
			'windSpeedMax': 5.9,
			'windSpeedMin': 2.1
		}
	},
	{
		'time': '2025-06-27T09:00:00Z',
		'values': {
			'altimeterSettingAvg': 1020.84,
			'altimeterSettingMax': 1022.46,
			'altimeterSettingMin': 1018.99,
			'cloudBaseAvg': 0.9,
			'cloudBaseMax': 2.5,
			'cloudBaseMin': 0,
			'cloudCeilingAvg': 0.1,
			'cloudCeilingMax': 2.9,
			'cloudCeilingMin': 0,
			'cloudCoverAvg': 22,
			'cloudCoverMax': 66,
			'cloudCoverMin': 2,
			'dewPointAvg': 15.8,
			'dewPointMax': 17.8,
			'dewPointMin': 13.8,
			'evapotranspirationAvg': 0.102,
			'evapotranspirationMax': 0.168,
			'evapotranspirationMin': 0.063,
			'evapotranspirationSum': 2.451,
			'freezingRainIntensityAvg': 0,
			'freezingRainIntensityMax': 0,
			'freezingRainIntensityMin': 0,
			'humidityAvg': 80,
			'humidityMax': 98,
			'humidityMin': 51,
			'iceAccumulationAvg': 0,
			'iceAccumulationLweAvg': 0,
			'iceAccumulationLweMax': 0,
			'iceAccumulationLweMin': 0,
			'iceAccumulationLweSum': 0,
			'iceAccumulationMax': 0,
			'iceAccumulationMin': 0,
			'iceAccumulationSum': 0,
			'moonriseTime': '2025-06-27T11:55:07Z',
			'moonsetTime': '2025-06-27T23:03:50Z',
			'precipitationProbabilityAvg': 0,
			'precipitationProbabilityMax': 0,
			'precipitationProbabilityMin': 0,
			'pressureSeaLevelAvg': 1019.49,
			'pressureSeaLevelMax': 1021.41,
			'pressureSeaLevelMin': 1017.04,
			'pressureSurfaceLevelAvg': 943.35,
			'pressureSurfaceLevelMax': 944.88,
			'pressureSurfaceLevelMin': 941.62,
			'rainAccumulationAvg': 0,
			'rainAccumulationMax': 0,
			'rainAccumulationMin': 0,
			'rainAccumulationSum': 0,
			'rainIntensityAvg': 0,
			'rainIntensityMax': 0,
			'rainIntensityMin': 0,
			'sleetIntensityAvg': 0,
			'sleetIntensityMax': 0,
			'sleetIntensityMin': 0,
			'snowAccumulationAvg': 0,
			'snowAccumulationLweAvg': 0,
			'snowAccumulationLweMax': 0,
			'snowAccumulationLweMin': 0,
			'snowAccumulationLweSum': 0,
			'snowAccumulationMax': 0,
			'snowAccumulationMin': 0,
			'snowAccumulationSum': 0,
			'snowIntensityAvg': 0,
			'snowIntensityMax': 0,
			'snowIntensityMin': 0,
			'sunriseTime': '2025-06-27T09:43:00Z',
			'sunsetTime': '2025-06-27T20:41:00Z',
			'temperatureApparentAvg': 19.9,
			'temperatureApparentMax': 26,
			'temperatureApparentMin': 15.3,
			'temperatureAvg': 19.9,
			'temperatureMax': 26,
			'temperatureMin': 15.3,
			'uvHealthConcernAvg': 0,
			'uvHealthConcernMax': 2,
			'uvHealthConcernMin': 0,
			'uvIndexAvg': 1,
			'uvIndexMax': 6,
			'uvIndexMin': 0,
			'visibilityAvg': 16,
			'visibilityMax': 16,
			'visibilityMin': 16,
			'weatherCodeMax': 1100,
			'weatherCodeMin': 1100,
			'windDirectionAvg': 227,
			'windGustAvg': 4.5,
			'windGustMax': 7.1,
			'windGustMin': 1.8,
			'windSpeedAvg': 2.2,
			'windSpeedMax': 3.9,
			'windSpeedMin': 0.9
		}
	},
	{
		'time': '2025-06-28T09:00:00Z',
		'values': {
			'altimeterSettingAvg': 1019.95,
			'altimeterSettingMax': 1022.47,
			'altimeterSettingMin': 1018.38,
			'cloudBaseAvg': 6.2,
			'cloudBaseMax': 12.8,
			'cloudBaseMin': 0,
			'cloudCeilingAvg': 6.4,
			'cloudCeilingMax': 13.1,
			'cloudCeilingMin': 0,
			'cloudCoverAvg': 57,
			'cloudCoverMax': 100,
			'cloudCoverMin': 5,
			'dewPointAvg': 14.6,
			'dewPointMax': 17.1,
			'dewPointMin': 13.1,
			'evapotranspirationAvg': 0.108,
			'evapotranspirationMax': 0.197,
			'evapotranspirationMin': 0.06,
			'evapotranspirationSum': 2.584,
			'freezingRainIntensityAvg': 0,
			'freezingRainIntensityMax': 0,
			'freezingRainIntensityMin': 0,
			'humidityAvg': 75,
			'humidityMax': 99,
			'humidityMin': 48,
			'iceAccumulationAvg': 0,
			'iceAccumulationLweAvg': 0,
			'iceAccumulationLweMax': 0,
			'iceAccumulationLweMin': 0,
			'iceAccumulationLweSum': 0,
			'iceAccumulationMax': 0,
			'iceAccumulationMin': 0,
			'iceAccumulationSum': 0,
			'moonriseTime': '2025-06-28T12:38:35Z',
			'moonsetTime': null,
			'precipitationProbabilityAvg': 0,
			'precipitationProbabilityMax': 0,
			'precipitationProbabilityMin': 0,
			'pressureSeaLevelAvg': 1018.55,
			'pressureSeaLevelMax': 1021.62,
			'pressureSeaLevelMin': 1016.51,
			'pressureSurfaceLevelAvg': 942.52,
			'pressureSurfaceLevelMax': 944.88,
			'pressureSurfaceLevelMin': 941.05,
			'rainAccumulationAvg': 0,
			'rainAccumulationMax': 0,
			'rainAccumulationMin': 0,
			'rainAccumulationSum': 0,
			'rainIntensityAvg': 0,
			'rainIntensityMax': 0,
			'rainIntensityMin': 0,
			'sleetIntensityAvg': 0,
			'sleetIntensityMax': 0,
			'sleetIntensityMin': 0,
			'snowAccumulationAvg': 0,
			'snowAccumulationLweAvg': 0,
			'snowAccumulationLweMax': 0,
			'snowAccumulationLweMin': 0,
			'snowAccumulationLweSum': 0,
			'snowAccumulationMax': 0,
			'snowAccumulationMin': 0,
			'snowAccumulationSum': 0,
			'snowIntensityAvg': 0,
			'snowIntensityMax': 0,
			'snowIntensityMin': 0,
			'sunriseTime': '2025-06-28T09:43:00Z',
			'sunsetTime': '2025-06-28T20:42:00Z',
			'temperatureApparentAvg': 19.5,
			'temperatureApparentMax': 26,
			'temperatureApparentMin': 14.7,
			'temperatureAvg': 19.5,
			'temperatureMax': 26,
			'temperatureMin': 14.7,
			'uvHealthConcernAvg': 0,
			'uvHealthConcernMax': 2,
			'uvHealthConcernMin': 0,
			'uvIndexAvg': 1,
			'uvIndexMax': 6,
			'uvIndexMin': 0,
			'visibilityAvg': 15.68,
			'visibilityMax': 16,
			'visibilityMin': 11.67,
			'weatherCodeMax': 1001,
			'weatherCodeMin': 1001,
			'windDirectionAvg': 68,
			'windGustAvg': 5,
			'windGustMax': 8.8,
			'windGustMin': 2.8,
			'windSpeedAvg': 2.4,
			'windSpeedMax': 4.1,
			'windSpeedMin': 0.2
		}
	},
	{
		'time': '2025-06-30T09:00:00Z',
		'values': {
			'altimeterSettingAvg': 1019.82,
			'altimeterSettingMax': 1020.73,
			'altimeterSettingMin': 1018.34,
			'cloudBaseAvg': 0.2,
			'cloudBaseMax': 1.8,
			'cloudBaseMin': 0,
			'cloudCeilingAvg': 0,
			'cloudCeilingMax': 0,
			'cloudCeilingMin': 0,
			'cloudCoverAvg': 13,
			'cloudCoverMax': 30,
			'cloudCoverMin': 0,
			'dewPointAvg': 13.1,
			'dewPointMax': 15.3,
			'dewPointMin': 11,
			'evapotranspirationAvg': 0.103,
			'evapotranspirationMax': 0.169,
			'evapotranspirationMin': 0.063,
			'evapotranspirationSum': 2.473,
			'freezingRainIntensityAvg': 0,
			'freezingRainIntensityMax': 0,
			'freezingRainIntensityMin': 0,
			'humidityAvg': 68,
			'humidityMax': 88,
			'humidityMin': 41,
			'iceAccumulationAvg': 0,
			'iceAccumulationLweAvg': 0,
			'iceAccumulationLweMax': 0,
			'iceAccumulationLweMin': 0,
			'iceAccumulationLweSum': 0,
			'iceAccumulationMax': 0,
			'iceAccumulationMin': 0,
			'iceAccumulationSum': 0,
			'moonriseTime': '2025-06-30T13:49:00Z',
			'moonsetTime': '2025-06-30T00:58:49Z',
			'precipitationProbabilityAvg': 0,
			'precipitationProbabilityMax': 0,
			'precipitationProbabilityMin': 0,
			'pressureSeaLevelAvg': 1018.12,
			'pressureSeaLevelMax': 1019.44,
			'pressureSeaLevelMin': 1016.31,
			'pressureSurfaceLevelAvg': 942.4,
			'pressureSurfaceLevelMax': 943.25,
			'pressureSurfaceLevelMin': 941.01,
			'rainAccumulationAvg': 0,
			'rainAccumulationMax': 0,
			'rainAccumulationMin': 0,
			'rainAccumulationSum': 0,
			'rainIntensityAvg': 0,
			'rainIntensityMax': 0,
			'rainIntensityMin': 0,
			'sleetIntensityAvg': 0,
			'sleetIntensityMax': 0,
			'sleetIntensityMin': 0,
			'snowAccumulationAvg': 0,
			'snowAccumulationLweAvg': 0,
			'snowAccumulationLweMax': 0,
			'snowAccumulationLweMin': 0,
			'snowAccumulationLweSum': 0,
			'snowAccumulationMax': 0,
			'snowAccumulationMin': 0,
			'snowAccumulationSum': 0,
			'snowIntensityAvg': 0,
			'snowIntensityMax': 0,
			'snowIntensityMin': 0,
			'sunriseTime': '2025-06-30T09:43:00Z',
			'sunsetTime': '2025-06-30T20:42:00Z',
			'temperatureApparentAvg': 19.8,
			'temperatureApparentMax': 26.7,
			'temperatureApparentMin': 13.1,
			'temperatureAvg': 19.8,
			'temperatureMax': 26.8,
			'temperatureMin': 13.1,
			'visibilityAvg': 16,
			'visibilityMax': 16,
			'visibilityMin': 16,
			'weatherCodeMax': 1000,
			'weatherCodeMin': 1000,
			'windDirectionAvg': 100,
			'windGustAvg': 3.3,
			'windGustMax': 7.3,
			'windGustMin': 0.7,
			'windSpeedAvg': 1.6,
			'windSpeedMax': 3.2,
			'windSpeedMin': 0.3
		}
	}

];

interface TableForecastProps {
	uuid_dam: string
}

export default function TableForecast({uuid_dam}: TableForecastProps) {

	const [data, setData] = useState<any | null>(null);

	useEffect(() => {
		getData(uuid_dam);
	}, []);

	async function getData(uuid_dam: string) {
		try{
			const response = await DamsServices.getForecast(uuid_dam);
			const previsao = JSON.parse(response.previsao); 
			setData(previsao.timelines.daily);
			console.log(previsao.timelines);
			
		}catch (error){
			console.log(error);
		}
	}	
	

	return (
		<Box height={'auto'} width={'100%'} sx={{ display: 'flex', flexDirection: 'row', gap: '1rem', overflowX: 'auto', paddingY: '1rem'}}>
			{data !== null && (
				data.map((dia: any) => (
					<Box key={dia.time} height={'11rem'} minWidth={'10rem'} border={1} sx={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '0.5rem', borderRadius: '25px', boxShadow: 'initial' }}>
						<Typography textAlign={'center'}>{formatDateWhitoutHour(dia.time)}</Typography>
						<Divider />
						<Typography textAlign={'center'}>Temp: {dia.values.temperatureMin + '°c'} / {dia.values.temperatureMax + '°c'}</Typography>
						<Typography textAlign={'center'}>Umidade: {dia.values.humidityAvg + '%'}</Typography>
						<Typography textAlign={'center'}>Precipitação: {dia.values.precipitationProbabilityAvg + '%'}</Typography>
						<Typography textAlign={'center'}>Vento: {dia.values.windSpeedAvg + 'Km/h'}</Typography>
					</Box>
				))
			)}
		</Box>
	);
}